import { useTheme } from "@mui/material";
import _ from "lodash";
import { StatisticsCard, type StatisticItem } from "src/components";
import type { FormSubmissionsReportRowDto } from "src/http";

interface Props {
  data: FormSubmissionsReportRowDto[] | undefined;
  isLoading: boolean;
  selectedTeamGuids: string[];
}

const EmployeeFeedbackSummary = (props: Props) => {
  const theme = useTheme();
  const uniqueUsers = _.uniqBy(props.data ?? [], (x) => x.recipientUser.userId);
  const userCount = uniqueUsers.length;
  const userPrimaryRoleCount = uniqueUsers.reduce((prev, curr) => {
    const hasPrimaryRole = curr.recipientUserRoles
      .filter((x) => props.selectedTeamGuids.includes(x.teamGuid))
      .some((x) => x.isPrimaryRole);

    if (hasPrimaryRole) {
      return prev + 1;
    } else {
      return prev;
    }
  }, 0);

  const groupedByFormName = _.groupBy(props.data ?? [], (x) => x.formName);

  const data: StatisticItem[] = _.map(_.sortBy(Object.keys(groupedByFormName)), (formName) => ({
    title: formName,
    value: groupedByFormName[formName].length,
  }));

  data.push(
    {
      title: "People In Roles",
      value: userCount,
    },
    {
      title: "People In Primary Roles",
      value: props.selectedTeamGuids.length === 0 ? "N/A" : userPrimaryRoleCount,
      sx: { color: props.selectedTeamGuids.length === 0 ? theme.palette.text.secondary : undefined },
    },
  );

  return <StatisticsCard isLoading={props.isLoading} data={data} />;
};

export { EmployeeFeedbackSummary };
